export default {
  path: 'training',
  meta: { title: '培训管理' },
  component: () => import(/* webpackChunkName: "training" */ '@/pages/training/TrainingList'),
  children: [
    {
      path: 'create',
      meta: { title: '新增培训' },
      component: () => import(/* webpackChunkName: "training-create" */ '@/pages/training/CreateEdit')
    },
    {
      path: ':id/edit',
      meta: { title: '编辑培训' },
      component: () => import(/* webpackChunkName: "training-edit" */ '@/pages/training/CreateEdit')
    },
    {
      path: ':id/enrollment',
      meta: { title: '报名列表' },
      component: () => import(/* webpackChunkName: "training-enrollment" */ '@/pages/training/EnrollmentList')
    }
  ]
}
